import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useActions, useFetch } from '@mssgme/hooks';
import { FieldError, Spinner } from '@mssgme/ui';
import AuthLayout from '../AuthLayout';
import RegistrationFormMember from './RegistrationFormMember';

import styles from './styles.scss';

export default function JoinByCode({ code }) {
    const { t } = useTranslation();
    const { api } = useActions();
    const { pending, result: invite, error, getValidationError } = useFetch(
        () => api.users.checkInvite({ payload: { code } }),
        [code]
    );
    const codeError = getValidationError('code');

    if (pending) return null;

    return (
        <AuthLayout>
            <div className={styles.root}>
                <div className={styles.header}>
                    <h1>{t('RegistrationPageMember.heading')}</h1>
                </div>

                {pending ? (
                    <Spinner />
                ) : error ? (
                    codeError ? (
                        <FieldError>{codeError}</FieldError>
                    ) : (
                        <div>{t('errorsList.expired_code')}</div>
                    )
                ) : (
                    invite && <RegistrationFormMember code={code} invite={invite} />
                )}
            </div>
        </AuthLayout>
    );
}

JoinByCode.propTypes = {
    code: PropTypes.string.isRequired,
};
